import { PortalError } from './PortalError';

export class NoStaffError extends PortalError {
  constructor() {
    super('NoStaffError', `No staff enlistments found for the user`);
  }
}
